import React from "react";
import ForgotPasswordForm from "../components/forms/ForgotPassword";
import logo from "../assets/logo2.png";
import bggImg from "../assets/bgg.jpg";

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-[#f5f5f0] flex flex-col lg:flex-row">
      {/* Left panel */}
      <div className="hidden lg:flex lg:w-[55%] relative bg-[#0d3d2e] flex-col justify-between p-12 overflow-hidden shrink-0">
        <div className="absolute inset-0">
          <img src={bggImg} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-[#0d3d2e]/80" />
        </div>
        <div className="relative z-10">
          <a href="/" className="flex items-center gap-3 mb-16 hover:opacity-90 transition">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg overflow-hidden">
              <img src={logo} alt="UCH" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <p className="text-white font-bold text-base leading-tight">UCH Self Service</p>
              <p className="text-green-300 text-xs">University College Hospital, Ibadan</p>
            </div>
          </a>

          <h1 className="text-5xl font-bold text-white leading-[1.1] mb-6">
            Forgot your<br />
            <span className="text-green-400">password?</span><br />
            No worries.
          </h1>
          <p className="text-green-200 text-base leading-relaxed max-w-sm mb-10">
            Enter the email linked to your account and we'll send you a secure reset link instantly.
          </p>

          <div className="space-y-5">
            {[
              { icon: "🔒", title: "Secure reset link", desc: "Valid for 24 hours, single use only" },
              { icon: "📧", title: "Check your inbox", desc: "Also check your spam / junk folder" },
              { icon: "✅", title: "Set a strong password", desc: "Use letters, numbers and symbols" },
            ].map((f) => (
              <div key={f.title} className="flex items-center gap-4">
                <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center text-lg shrink-0">{f.icon}</div>
                <div>
                  <p className="text-white font-semibold text-sm">{f.title}</p>
                  <p className="text-green-300 text-xs">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <p className="relative z-10 text-green-400 text-xs">
          © {new Date().getFullYear()} University College Hospital, Ibadan. All rights reserved.
        </p>
      </div>

      {/* Right panel */}
      <div className="flex-1 flex flex-col min-h-screen lg:min-h-0">
        {/* Mobile top bar */}
        <div className="lg:hidden bg-[#0d3d2e] px-5 py-4 flex items-center gap-3">
          <a href="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden">
              <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
            </div>
            <div>
              <p className="text-white font-bold text-sm leading-tight">UCH Self Service</p>
              <p className="text-green-300 text-xs">University College Hospital</p>
            </div>
          </a>
        </div>

        <div className="flex-1 flex items-center justify-center bg-[#f5f5f0] px-4 py-8 sm:px-6 sm:py-12">
          <div className="w-full max-w-[400px]">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8">
              <div className="mb-6 sm:mb-8">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">Reset your password</h2>
                <p className="text-gray-500 text-sm">Enter your email and we'll send a secure reset link.</p>
              </div>
              <ForgotPasswordForm />
            </div>
            <p className="text-center text-xs text-gray-400 mt-5">
              Remembered it?{" "}
              <a href="/login" className="text-[#0d3d2e] font-semibold hover:underline">Back to Sign in</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
